<template>
  <BasicTemplate>
    <h3>
      <router-link to="/game-rollouts">Progressive Rollouts</router-link>
      /
      Progressive Rollout #{{ $route.params.id }}
    </h3>
    <RolloutForm :rollout-id="$route.params.id" @cancel="goBack" @saved="onSaved" />
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../../templates/basic.vue';
import RolloutForm from './form.vue';

export default {
  name: 'GameRolloutEdit',
  components: { BasicTemplate, RolloutForm },
  methods: {
    goBack() {
      this.$router.push('/game-rollouts');
    },
    onSaved() {
      // Stay on edit page after save; list is reachable via breadcrumb.
    },
  },
};
</script>
